export default __webpack_public_path__ + "static/media/00.1a561e0b.jpg";